import { 
  Form,
  Button, 
  InputNumber, 
  Card,
  message
} from 'antd'
import { useEffect, useState } from 'react'
import ShopSelect from '../../../components/BaseInfoSelects/StoreSelectBase'
import service from "../../../@services";

const FreeShipping = () => {

  const [form] = Form.useForm()
  const [defaultVal, setDefaultVal] = useState()
  const [btnFlag, setBtnFlag] = useState(false)

  // 默认值
  const setDefault = (val) => {
    form.setFieldsValue({storeCode: val.storeCode})
    setDefaultVal({storeCode: val.storeCode})
  }
  // 改变门店
  const changeSelect = (val) => {
    form.resetFields()
    form.setFieldsValue({
      freightLimit: 58,
      freight: 6,
      storeCode: val
    })
  }
  // 获取详情
  const getDetail = async () => {
    let { storeCode } = form.getFieldValue()
    if(storeCode){
      try {
        const temRes = await service.mallManagement.getPackageDetails(storeCode)
        if(temRes && temRes.id){
          form.setFieldsValue(temRes)
        }else{
          form.setFieldsValue({
            freightLimit: temRes.freightLimit,
            freight: temRes.freight
          })
        }
      } catch (e){
        console.log(e)
      }
    }
  }
  // 保存数据
  const saveData = () => {
    let temFormVal = form.getFieldValue()
    if(temFormVal.freightLimit < 0){
      message.error('包邮金额必须大于等于0')
      return
    }
    if(temFormVal.freight < 0) {
      message.error('邮费必须大于等于0')
      return
    }
    const saveData = Object.assign({}, temFormVal)
    setBtnFlag(true)
    service.mallManagement.savePackageDetails(saveData).then(res => {
      message.success('保存成功')
    }).catch(err => console.log(err)).finally(() => {
      setBtnFlag(false)
    })
  }

  useEffect(() => {
    getDetail()
  }, [defaultVal])

  return (
    <Card>
      <Form
        form={form}
        style={{ paddingTop: 20 }}
        labelCol={{ span: 2 }}
      >
        <Form.Item
          name="storeCode"
          label="门店选择"
        >
          <ShopSelect keyVal='storeCode' OnOptionsLoad={setDefault} onChange={changeSelect} />
        </Form.Item>
        <Form.Item label="包邮金额">
          <Form.Item name="freightLimit" noStyle rules={[{ required: true, message: "包邮金额不能为空，小数点后两位" }]}>
            <InputNumber
              style={{ width: 160 }}
              controls={false}
              precision={2}
              min={0}
            />
          </Form.Item> 元
        </Form.Item>
        <Form.Item label="邮费">
          <Form.Item name="freight" noStyle rules={[{required: true,message: '请输入' }]}>
            <InputNumber
              style={{ width: 160 }}
              controls={false}
              precision={2}
              min={0}
            />
          </Form.Item> 元
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 2 }}>
          <Button 
            type="primary" 
            danger 
            onClick={saveData}
            disabled={btnFlag}
          >
            保存
          </Button>
        </Form.Item>
      </Form>
    </Card>
  )
}

export default FreeShipping